export default __webpack_public_path__ + "locales/ar-SA/DownloadDialog.json?hash=19c5f51790159130adbe2dc8ed70b435";